import { ChangeDetectionStrategy, Component, inject, input, output, signal } from "@angular/core";

import { IconField } from "primeng/iconfield";
import { InputIcon } from "primeng/inputicon";
import { InputText } from "primeng/inputtext";
import { ControlValueAccessor, NgControl } from "@angular/forms";

@Component({
  selector: "rr-ui-core-search",
  imports: [IconField, InputIcon, InputText],
  templateUrl: "./ui-core-search.component.html",
  styleUrl: "./ui-core-search.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCoreSearchComponent implements ControlValueAccessor {
  // DI
  ngControl = inject(NgControl, { optional: true, self: true });

  // Inputs
  placeholder = input<string>("Search");

  // Outputs
  searchKey = output<string>();

  // Template variables
  value = signal<null | string>(null);
  disabled = signal<boolean>(false);

  private onTouched: () => void = () => {
    /* */
  };
  private onChange: (_: string) => void = () => {
    /* */
  };

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: string): void {
    this.value.set(value);
  }

  registerOnChange(fn: (_: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  onSearchChange(value: string) {
    this.value.set(value);
    this.onChange(value);
    this.searchKey.emit(value);
  }

  onBlur() {
    this.onTouched();
  }
}
